import React from "react";
import {styled} from "@reside/ui";

/**
 * Mirrors `@reside/ui` `Navigation` layout (`dist/navigation/Navigation.js`) so we can drop the
 * default shadow and use a bottom border. `styled(Navigation)` does not work because `Navigation`
 * is a plain function component and does not forward `className` to the inner wrapper.
 */
const NavShell = styled.div`
  position: fixed;
  z-index: 998;
  top: 0;
  width: 100%;
  height: 70px;
  background-color: ${({theme}) => theme.color.white};
  box-shadow: none;
  border-bottom: 1px solid ${({theme}) => theme.color.borderGray};
`;

const NavContent = styled.div`
  box-sizing: border-box;
  display: flex;
  max-width: 1920px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  margin: 0 auto;
  padding: 0 2rem;
`;

export const AdminNavigationBar = ({
  children,
}: Readonly<{children?: React.ReactNode}>) => (
  <NavShell>
    <NavContent>{children}</NavContent>
  </NavShell>
);
